// src/pages/Auth/index.jsx
import React, { useState } from 'react';
import { Form, Input, Button, Tabs, message } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { usePostContext } from '../../App';
import { useNavigate } from 'react-router-dom';
import 'antd/dist/reset.css';
import './index.css';

const { TabPane } = Tabs;

const Auth = () => {
  const [activeTab, setActiveTab] = useState('login');
  const { handleLogin, handleRegister, registeredUsers } = usePostContext();
  const navigate = useNavigate();

  const onLoginFinish = (values) => {
    const { username, password } = values;
    const user = registeredUsers.find(u => u.username === username && u.password === password);
    
    if (user) {
      handleLogin(user);
      message.success('登录成功');
      navigate('/');
    } else {
      message.error('用户名或密码错误');
    }
  };

  const onRegisterFinish = (values) => {
    const { username, password } = values;
    
    // 检查用户名是否已存在
    const existingUser = registeredUsers.find(u => u.username === username);
    
    if (existingUser) {
      message.error('用户名已存在');
      return;
    }
    
    handleRegister({ username, password });
    message.success('注册成功，请登录');
    setActiveTab('login');
  };

  return (
    <div className="auth-container">
      <div className="auth-form-wrapper">
        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <TabPane tab="登录" key="login">
            <Form
              name="login"
              initialValues={{ remember: true }}
              onFinish={onLoginFinish}
              autoComplete="off"
            >
              <Form.Item
                name="username"
                rules={[{ required: true, message: '请输入用户名!' }]}
              >
                <Input prefix={<UserOutlined />} placeholder="用户名" />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: '请输入密码!' }]}
              >
                <Input.Password prefix={<LockOutlined />} placeholder="密码" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  登录
                </Button>
              </Form.Item>
            </Form>
          </TabPane>

          <TabPane tab="注册" key="register">
            <Form
              name="register"
              onFinish={onRegisterFinish}
              autoComplete="off"
            >
              <Form.Item
                name="username"
                rules={[{ required: true, message: '请输入用户名!' }]}
              >
                <Input prefix={<UserOutlined />} placeholder="用户名" />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: '请输入密码!' }]}
              >
                <Input.Password prefix={<LockOutlined />} placeholder="密码" />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                dependencies={['password']}
                rules={[
                  { required: true, message: '请确认密码!' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('两次输入的密码不一致!'));
                    },
                  }),
                ]}
              >
                <Input.Password prefix={<LockOutlined />} placeholder="确认密码" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  注册
                </Button>
              </Form.Item>
            </Form>
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default Auth;